export default __webpack_public_path__ + "static/media/trr-drink-juicecocktail-watermelonrose.9d924d85.png";